import React from 'react'
import { useSelector } from 'react-redux'
import { Link, useLocation } from 'react-router-dom'
import { allCrudNames, allPages, checkPageAccess } from '../lib/AllPageNames'
import { isInventoryModel } from '../lib/AllStaticVariables'
import Header from './Header'

function Onhover() {
  if (document.querySelector('.app').classList.contains('sidenav-toggled'))
    document.querySelector('.app').classList.add('sidenav-toggled-open')
}
function Outhover() {
  document.querySelector('.app').classList.remove('sidenav-toggled-open')
}

const Sidebar = () => {
  const location = useLocation()
  const { pathname } = location
  const splitLocation = pathname.split('/')
  const { pageTitle } = useSelector((state) => state.pageTitle)
  const { pageAccess } = useSelector((state) => state.user)

  const toggleOpen = (id) => {
    const mainEls = document.getElementsByClassName('side-item__list')
    let isSameEl = false

    for (let i = 0; i < mainEls.length; i++) {
      if (mainEls[i].id === id && mainEls[i].classList.contains('is-open')) {
        isSameEl = true
      }

      mainEls[i].classList.remove('is-open')
    }
    const topEl = document.getElementById(id)

    return isSameEl
      ? topEl.classList.remove('is-open')
      : topEl.classList.add('is-open')
  }
  return (
    <>
      <Header pageTitle={pageTitle} />
      <div className='sticky'>
        <div className='app-sidebar__overlay'></div>
        <aside
          className='app-sidebar'
          onMouseOver={() => Onhover()}
          onMouseOut={() => Outhover()}
        >
          {/* <CustomScrollbars> */}
          <div className='header side-header'>
            <Link className='header-brand1' to='/dashboard'>
              <img
                src='/images/logo-icon.png'
                className='header-brand-img light-logo'
                alt={'logo-1'}
              />
              <img
                src='/images/logo.png'
                className='header-brand-img light-logo1'
                alt={'logo-2'}
              />
            </Link>
          </div>
          <div className='main-sidemenu'>
            <ul className='side-menu list-inline' id='sidebar-main'>
              <li
                className={
                  splitLocation[1] === 'dashboard' ? 'slide active' : 'slide'
                }
              >
                <Link className='side-menu__item' to='/dashboard'>
                  <i className='m-icon m-icon--dashboard'></i>
                  <span className='side-menu__label'>Dashboard</span>
                </Link>
              </li>
              {checkPageAccess(
                pageAccess,
                allPages?.product,
                allCrudNames?.read
              ) && (
                <li
                  className={
                    splitLocation[1] === 'manage-product'
                      ? 'slide active'
                      : 'slide'
                  }
                >
                  <Link className='side-menu__item' to='/manage-product'>
                    <i className='m-icon m-icon--products'></i>
                    <span className='side-menu__label'>Products</span>
                    <i className=' fa angle fa-angle-right '></i>
                  </Link>
                </li>
              )}
              {checkPageAccess(
                pageAccess,
                allPages?.order,
                allCrudNames?.read
              ) && (
                <li
                  id='Order'
                  className={
                    splitLocation[1] === 'order' ||
                    splitLocation[1] === 'cancel-list' ||
                    splitLocation[1] === 'exchange-list' ||
                    splitLocation[1] === 'replace-list' ||
                    splitLocation[1] === 'return-list' ||
                    splitLocation[1] === 'initiate-order' ||
                    splitLocation[1] === 'failed-order'
                      ? 'side-item__list is-open'
                      : 'side-item__list'
                  }
                >
                  <div
                    className={
                      splitLocation[1] === 'order' ||
                      splitLocation[1] === 'cancel-list' ||
                      splitLocation[1] === 'exchange-list' ||
                      splitLocation[1] === 'replace-list' ||
                      splitLocation[1] === 'return-list' ||
                      splitLocation[1] === 'initiate-order' ||
                      splitLocation[1] === 'failed-order'
                        ? 'slide active'
                        : 'slide'
                    }
                  >
                    <div
                      className='side-menu__item'
                      style={{ cursor: 'pointer' }}
                      onClick={() => {
                        toggleOpen('Order')
                      }}
                    >
                      <i className='m-icon m-icon--orders'></i>

                      <span className='side-menu__label'>
                        <Link className='side-menu__item p-0 m-0'>
                          <span className='side-menu__label'>Order</span>
                          <i className=' fa angle fa-angle-right '></i>
                        </Link>
                      </span>
                      <i className='m-icon m-icon--down-arrow'></i>
                    </div>
                  </div>
                  <ul className='side-menu side-item__sub-list list-inline'>
                    <li
                      className={
                        splitLocation[1] === 'order'
                          ? 'slide subactive'
                          : 'slide'
                      }
                    >
                      <Link
                        className='side-menu__item side-menu__sub-items'
                        to='/order'
                      >
                        <span className='side-menu__label'>All Orders</span>
                      </Link>
                    </li>

                    <li
                      className={
                        splitLocation[1] === 'return-list'
                          ? 'slide subactive'
                          : 'slide'
                      }
                    >
                      <Link
                        className='side-menu__item side-menu__sub-items'
                        to='/return-list'
                      >
                        <span className='side-menu__label'>
                          Product Returns
                        </span>
                      </Link>
                    </li>
                    <li
                      className={
                        splitLocation[1] === 'initiate-order'
                          ? 'slide subactive'
                          : 'slide'
                      }
                    >
                      <Link
                        className='side-menu__item side-menu__sub-items'
                        to='/initiate-order'
                      >
                        <span className='side-menu__label'>
                          Initiate Orders
                        </span>
                      </Link>
                    </li>
                    <li
                      className={
                        splitLocation[1] === 'failed-order'
                          ? 'slide subactive'
                          : 'slide'
                      }
                    >
                      <Link
                        className='side-menu__item side-menu__sub-items'
                        to='/failed-order'
                      >
                        <span className='side-menu__label'>Failed Orders</span>
                      </Link>
                    </li>
                  </ul>
                </li>
              )}
              {/* {checkPageAccess(
                pageAccess,
                allPages?.invoice,
                allCrudNames?.read
              ) && */}
              {/* !isInventoryModel && ( */}
              <li
                className={
                  splitLocation[1] === 'customer-invoice'
                    ? 'slide active'
                    : 'slide'
                }
              >
                <Link className='side-menu__item' to='/customer-invoice'>
                  <i className='m-icon m-icon--sellers'></i>
                  <span className='side-menu__label'>Customer Invoice</span>
                  <i className=' fa angle fa-angle-right '></i>
                </Link>
              </li>
              {/* )} */}
              {checkPageAccess(
                pageAccess,
                allPages?.manageSeller,
                allCrudNames?.read
              ) &&
                !isInventoryModel && (
                  <li
                    className={
                      splitLocation[1] === 'manage-seller'
                        ? 'slide active'
                        : 'slide'
                    }
                  >
                    <Link className='side-menu__item' to='/manage-seller'>
                      <i className='m-icon m-icon--sellers'></i>
                      <span className='side-menu__label'>Seller</span>
                      <i className=' fa angle fa-angle-right '></i>
                    </Link>
                  </li>
                )}
              {checkPageAccess(
                pageAccess,
                allPages?.manageSeller,
                allCrudNames?.read
              ) &&
                isInventoryModel && (
                  <li
                    className={
                      splitLocation[1] === 'im-warehouse'
                        ? 'slide active'
                        : 'slide'
                    }
                  >
                    <Link className='side-menu__item' to='/im-warehouse'>
                      <i className='m-icon m-icon--sellers'></i>
                      <span className='side-menu__label'>Warehouse</span>
                      <i className=' fa angle fa-angle-right '></i>
                    </Link>
                  </li>
                )}
              {checkPageAccess(
                pageAccess,
                [allPages?.Brand, allPages?.assignBrandToSeller],
                allCrudNames?.read
              ) && (
                <li
                  className={
                    splitLocation[1] === 'manage-brand'
                      ? 'slide active'
                      : 'slide'
                  }
                >
                  <Link className='side-menu__item' to='/manage-brand'>
                    <i className='m-icon m-icon--brands'></i>
                    <span className='side-menu__label'> Brand</span>
                    <i className=' fa angle fa-angle-right '></i>
                  </Link>
                </li>
              )}
              {checkPageAccess(
                pageAccess,
                [
                  allPages?.category,
                  allPages?.size,
                  allPages?.color,
                  allPages?.assignAttributes
                ],
                allCrudNames?.read
              ) && (
                <li
                  id='maincategory'
                  className={
                    splitLocation[1] === 'category'
                      ? 'side-item__list is-open'
                      : 'side-item__list'
                  }
                >
                  <div
                    className={
                      splitLocation[1] === 'category' ? 'slide active' : 'slide'
                    }
                    onClick={() => {
                      toggleOpen('maincategory')
                    }}
                  >
                    <div
                      className='side-menu__item'
                      style={{ cursor: 'pointer' }}
                    >
                      <i className='m-icon m-icon--Categories'></i>
                      <span className='side-menu__label'>Categories</span>
                      <i className='m-icon m-icon--down-arrow'></i>
                    </div>
                  </div>
                  <ul className='side-menu side-item__sub-list list-inline'>
                    {checkPageAccess(
                      pageAccess,
                      allPages?.category,
                      allCrudNames?.read
                    ) && (
                      <li
                        className={
                          splitLocation[2] === 'manage-category'
                            ? 'slide subactive'
                            : 'slide'
                        }
                      >
                        <Link
                          className='side-menu__item side-menu__sub-items'
                          to='/category/manage-category'
                        >
                          <span className='side-menu__label'>Category</span>
                        </Link>
                      </li>
                    )}

                    {checkPageAccess(pageAccess, [
                      allPages?.size,
                      allPages?.color
                    ]) && (
                      <li
                        className={
                          splitLocation[2] === 'manage-attributes'
                            ? 'slide subactive'
                            : 'slide'
                        }
                      >
                        <Link
                          className='side-menu__item side-menu__sub-items'
                          to='/category/manage-attributes'
                        >
                          <span className='side-menu__label'>Attributes</span>
                        </Link>
                      </li>
                    )}

                    {checkPageAccess(
                      pageAccess,
                      allPages?.assignAttributes,
                      allCrudNames?.read
                    ) && (
                      <li
                        className={
                          splitLocation[2] === 'assign-category'
                            ? 'slide subactive'
                            : 'slide'
                        }
                      >
                        <Link
                          className='side-menu__item side-menu__sub-items'
                          to='/category/assign-category'
                        >
                          <span className='side-menu__label'>
                            Assign Attributes
                          </span>
                        </Link>
                      </li>
                    )}
                  </ul>
                </li>
              )}
              {checkPageAccess(
                pageAccess,
                allPages?.user,
                allCrudNames?.read
              ) && (
                <li
                  className={
                    splitLocation[1] === 'manage-user'
                      ? 'slide active'
                      : 'slide'
                  }
                >
                  <Link className='side-menu__item' to='/manage-user'>
                    <i className='m-icon m-icon--User'></i>
                    <span className='side-menu__label'>User</span>
                    <i className=' fa angle fa-angle-right '></i>
                  </Link>
                </li>
              )}
              {checkPageAccess(
                pageAccess,
                allPages?.report,
                allCrudNames?.read
              ) && (
                <li
                  className={
                    splitLocation[1] === 'report' ? 'slide active' : 'slide'
                  }
                >
                  <Link className='side-menu__item' to='/report'>
                    <i className='m-icon m-icon--User'></i>
                    <span className='side-menu__label'>Report</span>
                    <i className=' fa angle fa-angle-right '></i>
                  </Link>
                </li>
              )}
              {checkPageAccess(
                pageAccess,
                allPages?.manageCoupon,
                allCrudNames?.read
              ) && (
                <li
                  className={
                    splitLocation[1] === 'manage-coupons'
                      ? 'slide active'
                      : 'slide'
                  }
                >
                  <Link className='side-menu__item' to='/manage-coupons'>
                    <i className='m-icon m-icon--coupons'></i>
                    <span className='side-menu__label'> Coupon</span>
                    <i className=' fa angle fa-angle-right '></i>
                  </Link>
                </li>
              )}
              {checkPageAccess(
                pageAccess,
                allPages?.settings,
                allCrudNames?.read
              ) && (
                <li
                  className={
                    splitLocation[1] === 'settings' ? 'slide active' : 'slide'
                  }
                >
                  <Link className='side-menu__item' to='/settings'>
                    <i className='m-icon m-icon--setting'></i>
                    <span className='side-menu__label'>Settings</span>
                    <i className=' fa angle fa-angle-right '></i>
                  </Link>
                </li>
              )}
              {checkPageAccess(
                pageAccess,
                allPages?.logs,
                allCrudNames?.read
              ) && (
                <li
                  className={
                    splitLocation[1] === 'logs' ? 'slide active' : 'slide'
                  }
                >
                  <Link className='side-menu__item' to='/logs'>
                    <i className='m-icon m-icon--Logs'></i>
                    <span className='side-menu__label'>Logs</span>
                    <i className=' fa angle fa-angle-right '></i>
                  </Link>
                </li>
              )}
            </ul>
          </div>
          {/* </CustomScrollbars> */}
        </aside>
      </div>
    </>
  )
}

export default Sidebar
